import styled from 'styled-components'

export const Floating = styled.div`
  position: absolute;
  display: none;

  @media only screen and (min-width: 800px) {
    display: flex;
    &[data-position='bottom'] {
      top: 100%;
      left: 50%;
      transform: translate(-50%, 9px);

      ::after {
        top: 0;
        left: 50%;
        transform: translate(-50%, calc(-100% + 1px));

        border-bottom: 10px solid #2c2c2c;
      }
    }

    &[data-position='left'] {
      top: 50%;
      left: 0;
      transform: translate(calc(-100% - 15px), -50%);

      ::after {
        top: 50%;
        right: 0;
        transform: translate(calc(100%), -50%);

        border-left: 10px solid #2c2c2c;
      }
    }

    &[data-position='right'] {
      top: 50%;
      right: 0;
      transform: translate(calc(100% + 9px), -50%);

      ::after {
        top: 50%;
        left: 0;
        transform: translate(calc(-100% + 1px), -50%);

        border-right: 10px solid #2c2c2c;
      }
    }

    &[data-position='top'] {
      top: 0;
      left: 50%;
      transform: translate(-50%, calc(-100% - 9px));

      ::after {
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 100%);

        border-top: 10px solid #2c2c2c;
      }
    }
  }

  color: #fff;
  font-size: 12px;
  font-weight: 600;

  background: #2c2c2c;

  border-radius: 4px;

  padding: 8px 12px !important;
  z-index: 10;

  opacity: 0;
  pointer-events: none;

  transition: opacity 0.3s ease;

  width: max-content;

  ::after {
    content: '';
    display: block;
    width: 0;
    height: 0;

    position: absolute;

    border: 5px solid transparent;
  }
`

export const Container = styled.div`
  position: relative;

  &:hover {
    ${Floating} {
      opacity: 1;
    }
  }
`
